
  import { css } from 'lit';
  export const styles = css`:host{--resting-background: var(--ig-highlight-resting-background, var(--ig-gray-200));--resting-color: var(--ig-highlight-resting-color, var(--ig-gray-200-contrast));--ig-theme-variant: dark}`;
  